import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsErlangComponent } from './simple-icons-erlang.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsErlangComponent ],
    exports:      [ SimpleIconsErlangComponent ],
    bootstrap:    []
})
export class SimpleIconsErlangModule {}
